export default {
  namespaced: true,

  state: {
    type: null,
  },

  getters: {
    type: state => {
      return state.type;
    },

    get: state => {
      return state;
    },
  },

  mutations: {
    type: (state, type) => {
      state.type = type;
    },
  },

  actions: {
    init({dispatch}) {
      dispatch('initType');
    },

    initType({commit}) {
      const pageMeta = window.ShopifyAnalytics.meta.page || {};

      // round one: by meta pageType
      let type = pageMeta.pageType || null;

      // round two: by meta path
      let path = pageMeta.path || null;
      if (!type && path) {
        if (path === '/checkout/thank_you') {
          type = 'order';
        }
      }

      // round three: by url
      if (!type) {
        const pathname = window.location.pathname;
        if (pathname.indexOf('/products/') !== -1) {
          type = 'product'; // single product page
        }

        // authenticated customer is redirected here after checkout
        if (pathname.indexOf('/checkouts/') !== -1 && pathname.indexOf('/thank_you') !== -1) {
          type = 'order'; // checkout thank_you page
        }
        // not authenticated customer will be redirected here after checkout
        // authenticated customer can access it from ORDER HISTORY
        if (pathname.indexOf('/orders/') !== -1) {
          type = 'order';
        }

        // Unused
        if (pathname.indexOf('/cart') !== -1) {
          type = 'cart'; // cart page
        }
      }

      commit('type', type);
    },
  },

};
